import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'secureDom'
})
export class SecureDomPipe implements PipeTransform {

  constructor(
    private domSanitizer: DomSanitizer
  ) {}

  transform(value: string): any {
    console.log(value);
    return this.domSanitizer.bypassSecurityTrustResourceUrl(value);
  }

}



// WEBPACK FOOTER //
// /app/src/app/pipes/secure-dom.pipe.ts